import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageListManualBlock, PageListViewType } from '@/declarations/models/blocks/PageListBlocks';
import { BlockPreviewComponent } from '../../../lib/declarations/EditorComponentTypes';
import { useCurrentBlock } from '../../CurrentBlockProvider';
import PageListBlockPreviewItem from './PageListBlockPreviewItem';

export const PageListManualBlockPreview: BlockPreviewComponent = () => {
  const { t } = useTranslation('common');
  const { block } = useCurrentBlock();
  const currentBlock = block as PageListManualBlock;

  return (
    <div
      className={`pagelist pagelist--${currentBlock.view || 'grid'} pagelist--${currentBlock?.grid33 ? 'grid33' : ''} ${
        currentBlock?.removeLeftPadding ? 'util-no-left-padding' : ''
      }`}>
      <div className='pagelist__intro'>
        {block?.visibletitle && block?.title && <h2>{block?.title}</h2>}
        {block?.body && <p style={{ whiteSpace: 'pre-line' }}>{block?.body}</p>}
      </div>
      {currentBlock.enableSearch && (
        <div className='pagelist__intro'>
          <input style={{ marginBottom: '1em', maxWidth: '780px' }} type='text' placeholder={t('search')} />
        </div>
      )}
      {(currentBlock?.view === PageListViewType.GRID ||
        currentBlock?.view === PageListViewType.SIMPLE ||
        !currentBlock?.view) && (
        <>
          <div className={`pagelist__grid gridMobileBehaviour-${currentBlock?.gridMobileBehaviour || 'auto'}`}>
            {currentBlock?.items?.map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <PageListBlockPreviewItem key={`${item.id}-${index}`} item={item} block={currentBlock} />
            ))}
          </div>
          {currentBlock?.showAllLinkPage?.id && (
            <div className='row__footer'>
              <div className='pagelist__intro'>
                <span className='module__button'>
                  {currentBlock?.showAllLinkPage?.local?.title || currentBlock?.showAllLinkPage?.title}
                </span>
              </div>
            </div>
          )}
        </>
      )}

      {currentBlock?.view === PageListViewType.LIST && (
        <div className={`row row--cards row--list gridMobileBehaviour-${currentBlock?.gridMobileBehaviour || 'auto'}`}>
          <div className='row__grid'>
            <div className='row__content'>
              {currentBlock?.items?.map((item, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <PageListBlockPreviewItem key={`${item.id}-${index}`} item={item} block={currentBlock} />
              ))}
            </div>
            {currentBlock?.showAllLinkPage?.id && (
              <div className='row__footer'>
                <div className='pagelist__intro'>
                  <span className='module__button'>
                    {currentBlock?.showAllLinkPage?.local?.title || currentBlock?.showAllLinkPage?.title}
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PageListManualBlockPreview;
